<tt-page *ngIf="!!menu">
    <tt-card class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <ng-container *ngTemplateOutlet="info"></ng-container>
        <tt-button-goto ttText="create_pofinish" ttGoto="pofinishprod" [ttGotoParms]="{ po_keyno: menu.po_keyno, p2_pofinishprod_keyno: menu.p2_pofinishprod_keyno }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <div class="col-xs-12 sp-0" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card class="col-xs-12 col-md-4 p-5">
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>

        <tt-card class="col-xs-12 col-md-2 p-5">
            <tt-button-goto ttText="create_pofinish" ttGoto="pofinishprod" [ttGotoParms]="{ po_keyno: menu.po_keyno, p2_pofinishprod_keyno: menu.p2_pofinishprod_keyno }" ttIcon="far fa-plus"></tt-button-goto>
        </tt-card>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!menu">
        <tt-input ttLabel="prod_order" [ttModel]="menu.poh_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="prod_id" [ttModel]="menu.prod_id" ttReadonly></tt-input>
        <tt-input ttLabel="prod_name" [ttModel]="menu.prod_name" ttReadonly></tt-input>
        <tt-input-number ttLabel="quantity" [ttModel]="menu.quantity" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input-number ttLabel="quantity_finished" [ttModel]="menu.quantity_finished" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input-number ttLabel="quantity_rest" [ttModel]="menu.quantity_rest" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
    </ng-container>
</ng-template>
